import React from 'react';
import Hero from '../components/sections/Hero';
import TrustBand from '../components/sections/TrustBand';
import DemoInteractive from '../components/sections/DemoInteractive';
import Features from '../components/sections/Features';
import UseCasesBySector from '../components/sections/UseCasesBySector';
import SocialProof from '../components/sections/SocialProof';
import About from '../components/sections/About';
import FAQ from '../components/sections/FAQ';
import FinalCTA from '../components/sections/FinalCTA';

// Header and Footer are provided by the global layout in App.tsx — do not render
// them here (doing so produced duplicate, stacked headers/footers on the home page).
const Home: React.FC = () => {
  return (
    <>
      <Hero />
      <TrustBand />
      <DemoInteractive />
      <Features />
      <UseCasesBySector />
      <SocialProof />
      <About />
      <FAQ />
      <FinalCTA />
    </>
  );
};

export default Home;
